import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { IdentifierTypeViewModel } from '../../../models/Entities/Person/IdentifierType/IdentifierTypeModels';

// store
import * as IdentifierTypesStore from '../../../redux/middleware/PersonIdentifierTypes.Middleware';

export interface IProps {}

interface ConnectedProps {
  isLoading: boolean | undefined;
  isLoadingSuccessfully: boolean | undefined;
  failOnLoading: boolean | undefined;
  isDeleting: boolean | undefined;
  failOnDeleting: boolean | undefined;
  error: ErrorType | undefined;
  identifierTypes: IdentifierTypeViewModel[];
}

interface DispatchProps {
  GetIdentifierTypes: typeof IdentifierTypesStore.actionCreators.GetIdentifierTypes;
  DeleteIdentifierType: typeof IdentifierTypesStore.actionCreators.DeleteIdentifierType;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isLoading: state.PersonIdentifierTypes?.isLoadingAll,
  isLoadingSuccessfully: state.PersonIdentifierTypes?.successLoadingAll,
  failOnLoading: state.PersonIdentifierTypes?.failOnLoadingAll,
  isDeleting: state.PersonIdentifierTypes?.isDeletingOne,
  failOnDeleting: state.PersonIdentifierTypes?.failOnDeletingOne,
  error: state.PersonIdentifierTypes?.error,
  identifierTypes: (state.PersonIdentifierTypes?.list ?? [])
    .filter((item: IdentifierTypeViewModel) => !item.isDeleted)
    .slice()
    .sort((a: IdentifierTypeViewModel, b: IdentifierTypeViewModel) =>
      (a.name || '').localeCompare(b.name || '')
    ),
  ...ownProps
});

export const mapDispatchToProps = {
  ...IdentifierTypesStore.actionCreators
};
